import { api } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';
import { Availability } from './availability.interface';

export default {
   async get(candidate_id: number, between_start: string, between_end: string, cancel_token: CancelToken) {
      let scope = `${between_start},${between_end}`;
      return await api
         .get(`/availability`, {
            params: {
               candidate_id,
               'filter[between]': scope,
            },
            cancelToken: cancel_token,
         })
         .catch(() => { })
         .then((response) => {
            return response?.data;
         });
   },
};
